import { parse as parseDate } from 'date-fns';

import {
  SET_FIRST_AVAILABLE_TIME_SLOT,
  SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID
} from './actionTypes';

function calcFirstAvailableTimeSlot(days) {
  if (days) {
    let i;
    for (i = 0; i < days.length; i += 1) {
      const { isOpen, timeslots, calendarDate } = days[i];
      if (isOpen && timeslots && timeslots.length > 0) {
        return {
          time: parseDate(`${calendarDate}T${timeslots[0].time}`),
          teamsId: timeslots[0].teamIds || null
        };
      }
    }
  }
  return null;
}

export const setFirstAvailableTimeSlot = days => dispatch => {
  const timeslot = calcFirstAvailableTimeSlot(days);
  if (!timeslot) {
    return null;
  }
  dispatch({
    type: SET_FIRST_AVAILABLE_TIME_SLOT,
    payload: timeslot.time || null
  });

  dispatch({
    type: SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID,
    payload: timeslot.teamsId || null
  });
};



// WEBPACK FOOTER //
// ./src/store/reducers/firstAvailableTimeSlot/actions.js